import { CircleX as CircleXIcon } from 'lucide-react';

const variantClasses = {
    primary: 'bg-primary-100 text-primary-800',
    secondary: 'bg-secondary-100 text-secondary-800',
    success: 'bg-success-100 text-success-800',
    danger: 'bg-danger-100 text-danger-800',
    warning: 'bg-warning-100 text-warning-800',
    info: 'bg-info-100 text-info-800',
};

const removeBtnClasses = {
    primary: 'text-primary-400 hover:text-primary-600',
    secondary: 'text-secondary-400 hover:text-secondary-600',
    success: 'text-success-400 hover:text-success-600',
    danger: 'text-danger-400 hover:text-danger-600',
    warning: 'text-warning-400 hover:text-warning-600',
    info: 'text-info-400 hover:text-info-600',
};

const Chip = ({ label, onRemove, variant = 'info', className }) => {
    return (
        <div
            className={`w-fit inline-flex items-center gap-2 px-3 py-1 rounded ${variantClasses[variant]} ${className}`}
        >
            <span className="text-xs font-normal">{label}</span>
            {onRemove && (
                <button
                    onClick={onRemove}
                    className={removeBtnClasses[variant]}
                >
                    <CircleXIcon className="h-4 w-4" />
                </button>
            )}
        </div>
    );
};

export default Chip;
